import { render, staticRenderFns } from "./procurement_party.vue?vue&type=template&id=934a6c70&scoped=true&"
import script from "./procurement_party.vue?vue&type=script&lang=js&"
export * from "./procurement_party.vue?vue&type=script&lang=js&"
import style0 from "./procurement_party.vue?vue&type=style&index=0&id=934a6c70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934a6c70",
  null
  
)

export default component.exports